import { outreachAnalyticsSchema } from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import { OutreachGroupKeySchema } from "@redotech/redo-model/aggregated-metrics/outreach";
import * as z from "zod/v4";

export const getOutreachAnalytics = {
  name: "getOutreachAnalytics" as const,
  input: z.object({ groupBy: OutreachGroupKeySchema }),
  output: outreachAnalyticsSchema,
};
